import { render, staticRenderFns } from "./EngagementRingIcon.vue?vue&type=template&id=d2ad77fa&"
import script from "./EngagementRingIcon.vue?vue&type=script&lang=js&"
export * from "./EngagementRingIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports